import { MapPin, X } from "lucide-react";
import { useLocationContext } from "@/lib/prayer/location-context";

/**
 * Tiny dismissible bottom-right banner shown on first visit. Asks for
 * geolocation consent so jadwal sholat / cross-link cards reflect the
 * user's actual city. Falls back silently to Jakarta on dismiss/denial.
 */
export function LocationConsentBanner() {
  const { shouldPrompt, requestGeolocation, dismissPrompt } = useLocationContext();
  if (!shouldPrompt) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm rounded-lg border border-prayer/40 bg-card p-4 shadow-lg">
      <div className="flex items-start gap-3">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-prayer/15 text-prayer">
          <MapPin className="h-4 w-4" />
        </span>
        <div className="flex-1 text-sm">
          <p className="font-semibold">Tampilkan jadwal sesuai lokasi Anda?</p>
          <p className="mt-1 text-xs text-muted-foreground">
            Lokasi hanya dipakai untuk menentukan kota terdekat. Tidak disimpan
            di server.
          </p>
          <div className="mt-3 flex gap-2">
            <button
              onClick={requestGeolocation}
              className="rounded-md bg-prayer px-3 py-1.5 text-xs font-medium text-prayer-foreground hover:bg-prayer/90"
            >
              Izinkan
            </button>
            <button
              onClick={dismissPrompt}
              className="rounded-md border border-border px-3 py-1.5 text-xs hover:bg-accent"
            >
              Pakai Jakarta
            </button>
          </div>
        </div>
        <button
          onClick={dismissPrompt}
          aria-label="Tutup"
          className="text-muted-foreground hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}